module.exports = {"Type":"Start","Fields":[{"label":"Scenario Name","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"#88B688","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Start.json
// module id = 707
// module chunks = 0